import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";

export default function AdminDashboard() {
  const [kpi, setKpi] = useState(null);
  useEffect(() => { api.get("/admin/kpi").then((r) => setKpi(r.data)); }, []);
  if (!kpi) return <div className="text-falke-blue">Lade…</div>;
  const cards = [
    { label: "Kunden gesamt", val: kpi.total_kunden, link: "/admin/users" },
    { label: "Aktive Kunden", val: kpi.aktive_kunden, success: true },
    { label: "Offene Self-Signups", val: kpi.offene_signups, orange: true, link: "/admin/signups" },
    { label: "Offene Gewerbe-Anträge", val: kpi.offene_gewerbe, orange: true, link: "/admin/gewerbe" },
    { label: "Offene Empfehlungen", val: kpi.offene_empfehlungen, link: "/admin/empfehlungen" },
    { label: "Fertige Empfehlungen", val: kpi.fertige_empfehlungen, success: true, link: "/admin/vollzahlungen" },
    { label: "Offene Provisionen", val: kpi.offene_provisionen, orange: true, link: "/admin/provisionen" },
    { label: "Offene Service-Fälle", val: kpi.offene_tickets, orange: true, link: "/admin/service" },
  ];
  return (
    <div className="space-y-6" data-testid="admin-dashboard">
      <div>
        <h1 className="text-3xl font-heading font-bold text-falke-blue">Admin-Cockpit</h1>
        <p className="text-falke-anthracite/70">Operative Übersicht über das Empfehlungs-Programm.</p>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {cards.map((c) => (
          <a key={c.label} href={c.link || "#"} className="falke-card p-5 falke-card-hover block" data-testid={`kpi-${c.label}`}>
            <div className="text-xs text-falke-blue/60 uppercase tracking-wider">{c.label}</div>
            <div className={`font-heading text-3xl mt-1 tabular font-bold ${c.success ? "text-falke-success" : c.orange ? "text-falke-orange" : "text-falke-blue"}`}>{c.val}</div>
          </a>
        ))}
      </div>
      <CronTrigger />
    </div>
  );
}

function CronTrigger() {
  const [msg, setMsg] = useState("");
  const trigger = async () => {
    const r = await api.post("/admin/cron/sperrfrist");
    setMsg(`Auszahlungen verarbeitet: ${r.data.verarbeitet}`);
  };
  return (
    <div className="falke-card p-5">
      <h3 className="font-heading text-lg text-falke-blue">Sperrfrist-Verarbeitung</h3>
      <p className="text-sm text-falke-anthracite/70 mb-3">Alle Empfehlungen, deren 7-Tage-Sperrfrist abgelaufen ist, jetzt verarbeiten (Coins gutschreiben bzw. Provisionen erstellen).</p>
      <button onClick={trigger} className="btn-secondary" data-testid="cron-trigger">Jetzt ausführen</button>
      {msg && <div className="text-sm text-falke-success mt-2" data-testid="cron-result">{msg}</div>}
    </div>
  );
}
